export default "__VITE_ASSET__Dis5HKIM__"